import React from 'react';

export default function CampaignIdeasCarousel({ ideas, expandedCards, setExpandedCards }: { ideas: any[], expandedCards: {[key: string]: boolean}, setExpandedCards: React.Dispatch<React.SetStateAction<{[key: string]: boolean}>> }) {
  const [startIdx, setStartIdx] = React.useState(0);
  const visibleCount = 4;
  const canScrollLeft = startIdx > 0;
  const canScrollRight = startIdx + visibleCount < ideas.length;

  const handleScrollLeft = () => setStartIdx(idx => Math.max(0, idx - visibleCount));
  const handleScrollRight = () => setStartIdx(idx => Math.min(ideas.length - visibleCount, idx + visibleCount));

  if (!ideas.length) {
    return <div className="text-gray-400 col-span-2">No campaign ideas found for these filters.</div>;
  }
  return (
    <div className="flex flex-col items-center w-full">
      <div className="flex items-center gap-2 w-full justify-center mb-2">
        <button
          className={`rounded-full p-2 bg-blue-100 hover:bg-blue-200 text-primary disabled:opacity-30 disabled:pointer-events-none`}
          onClick={handleScrollLeft}
          disabled={!canScrollLeft}
          aria-label="Scroll left"
        >
          {'<'}
        </button>
        <div className="flex gap-4 overflow-x-auto max-w-full py-2">
          {ideas.slice(startIdx, startIdx + visibleCount).map((idea, idx) => {
            const cardKey = (idea.title || idx) + '-' + (startIdx + idx);
            const expanded = !!expandedCards[cardKey];
            const toggleExpanded = () => setExpandedCards((prev: any) => ({ ...prev, [cardKey]: !prev[cardKey] }));
            const formatIcons: Record<string, JSX.Element> = {
              'In-person Event': <span role="img" aria-label="in-person">🤝</span>,
              'Virtual Volunteering': <span role="img" aria-label="virtual">💻</span>,
              'Donation Drive': <span role="img" aria-label="donation">🎁</span>,
              'Awareness Campaign': <span role="img" aria-label="awareness">📢</span>,
              'Skill-Based Volunteering': <span role="img" aria-label="skill">🧑‍💼</span>,
            };
            const copyToClipboard = (text: string) => navigator.clipboard.writeText(text);
            return (
              <div
                key={cardKey}
                className="bg-white border border-blue-100 rounded-xl shadow p-5 flex flex-col gap-2 min-w-[260px] max-w-[260px] h-full items-stretch justify-between relative animate-fadeIn"
                style={{ minHeight: 260 }}
              >
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-2xl">{formatIcons[idea.format] || <span role="img" aria-label="idea">💡</span>}</span>
                  <span className="font-bold text-base flex-1">{idea.title}</span>
                  <span className="ml-2 text-xs bg-primary/10 text-primary px-2 py-0.5 rounded font-semibold">{idea.format}</span>
                </div>
                <div className="text-gray-700 text-sm mb-1">{idea.description}</div>
                <button
                  className="text-xs text-blue-700 underline w-fit mb-1"
                  onClick={toggleExpanded}
                >
                  {expanded ? 'Hide Communication Copy' : 'Show Communication Copy'}
                </button>
                {expanded && (
                  <div className="flex flex-col gap-2 mt-1">
                    <div>
                      <span className="font-medium text-xs text-gray-500">Email copy:</span>
                      <div className="flex items-center gap-2 mt-1">
                        <div className="bg-blue-50 border rounded p-2 text-xs text-gray-700 flex-1">{idea.copy.email}</div>
                        <button
                          className="text-xs px-2 py-1 rounded bg-blue-100 hover:bg-blue-200 text-primary font-semibold"
                          onClick={() => copyToClipboard(idea.copy.email)}
                          title="Copy email copy"
                        >Copy</button>
                      </div>
                    </div>
                    <div>
                      <span className="font-medium text-xs text-gray-500">Slack copy:</span>
                      <div className="flex items-center gap-2 mt-1">
                        <div className="bg-blue-50 border rounded p-2 text-xs text-gray-700 flex-1">{idea.copy.slack}</div>
                        <button
                          className="text-xs px-2 py-1 rounded bg-blue-100 hover:bg-blue-200 text-primary font-semibold"
                          onClick={() => copyToClipboard(idea.copy.slack)}
                          title="Copy Slack copy"
                        >Copy</button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <button
          className={`rounded-full p-2 bg-blue-100 hover:bg-blue-200 text-primary disabled:opacity-30 disabled:pointer-events-none`}
          onClick={handleScrollRight}
          disabled={!canScrollRight}
          aria-label="Scroll right"
        >
          {'>'}
        </button>
      </div>
    </div>
  );
}
